import { configureStore, combineReducers } from "@reduxjs/toolkit";

import addGuestReducer from "./slice/Addguest.slice";
import widgetSettingReducer from "./slice/widgetSetting.slice";
import feedbackReducer from "./slice/feedback.slice";
import webshopReducer from "./slice/Webshop.slice";
import ActivityReducer from "./slice/Activity.slice";
import TicketingReducer from "./slice/Ticketing.slice";
import CombinationReducer from "./slice/Combination.slice";
import salonReducer from "./slice/Salon.slice";
import webshopontwerpReducer from "./slice/Webshopontwerp.slice";

/**
 * No persistence — all widget slices use plain in-memory Redux state.
 * Every fresh widget load starts from the slice initialState.
 * API data is always fetched fresh; no stale data can ever be shown.
 */
const rootReducer = combineReducers({
  addGuest: addGuestReducer,
  widgetSettings: widgetSettingReducer,
  feedback: feedbackReducer,
  Webshop: webshopReducer,
  Activity: ActivityReducer,
  Ticketing: TicketingReducer,
  Combination: CombinationReducer,
  salon: salonReducer,
  // Het ontwerp uit de webshop-editor (13-10-2026).
  Webshopontwerp: webshopontwerpReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }),
});
